<!--
  Two-mode S3 Template modal — strict legacy parity with
  `ui/app/components/formView/templates/s3-template-view.html`.
  The two views are kept STRICTLY separate, each driven by a distinct
  click action on the grid toolbar:

    - "Upload Template" action  -> no rowData supplied to the modal
      -> initModal() sets `newUpload = true`
      -> renders ONLY the upload form (form picker + file input +
         comment + Upload button). No PDF iframe, no toolbar, no
         comments panel. Mirrors legacy `ng-if="::ctrl.newUpload"`
         block (L210-L229).

    - "View PDF" action (row click) -> rowData supplied
      -> initModal() leaves `newUpload = false`
      -> renders ONLY the PDF iframe + comments below (no icon toolbar
         above the PDF). Mirrors legacy `ng-if="::!ctrl.newUpload"`
         accordion (L230-L461) minus the inline replace-form, which is
         reached via the separate "Upload Template" action instead of mixed
         into the PDF view.

  The two `*ngIf` blocks below are mutually exclusive: when one is in
  the DOM the other is not, so the PDF view and the upload view are
  never visible in the same modal at the same time.
-->
@if (visible) {
<div class="s3-overlay"
    
     [ngClass]="currentTheme"
     [class.s3-overlay--embedded]="hostedInDialog"
     [class.s3-overlay--upload-compact]="newUpload && hostedInDialog">
  <div class="s3-modal"
       [class.s3-modal--embedded]="hostedInDialog"
       [class.s3-modal--upload-only]="newUpload">

    <div class="modal-header">
      <h4>{{ newUpload ? 'Upload PDF Template' : 'PDF S3 Template' }}</h4>
      <i class="fa fa-times pull-right hoverable" (click)="close()"></i>
    </div>

    <!-- ============================================================ -->
    <!-- Mode A: Upload-only (newUpload === true)                      -->
    <!-- ============================================================ -->
    @if (newUpload) {
<div class="modal-body upload-only-body">
      <div class="upload-form">
        <label class="upload-form-label" for="s3-upload-form-dropdown">Please Select a form:</label>
        <div class="form-select-wrap">
          <ap-dropdown class="upload-form-dropdown" [list]="formDropdownItems" [selectType]="'single'"
            inputId="s3-upload-form-dropdown" [title]="'Form'" [hideTitleOnInput]="true" [inputAriaLabel]="'Form'"
            [disabled]="loadingDD || formlist.values.length === 0"
            [(ngModel)]="selectedFormItem" (onSelect)="onFormDropdownSelect($event)">
            @for (item of formDropdownItems; track $index) {
              <ap-dropdown-list-item #dropdownListItem [item]="item"
                [ariaLabel]="setDropdownAriaLabel(item, 'Form')"
                (onSelectItem)="onFormSelectItem($event)"></ap-dropdown-list-item>
            }
          </ap-dropdown>
          @if (loadingDD) {
<div class="inline-loader">
            <i class="fa fa-spinner fa-spin"></i> Loading forms...
          </div>
}
        </div>

        <label class="upload-form-label">Please select a file:</label>
        <input type="file"
               class="upload-file-input"
               accept=".pdf"
               (change)="onFileSelected($event)" />
        @if (pdfFile) {
<div class="selected-file-name">{{ pdfFile.name }}</div>
}

        <label class="upload-form-label" for="s3-upload-comment">Please enter a comment:</label>
        <textarea id="s3-upload-comment"
                  class="upload-comment-input form-control"
                  rows="4"
                  [(ngModel)]="comment"
                  placeholder="Please add your comment here..."></textarea>

        <div class="upload-form-actions">
          <button type="button"
                  class="upload-submit-btn"
                  (click)="upload()"
                  [disabled]="!pdfFile || !comment || !selectedForm">
            <i class="fa fa-upload" aria-hidden="true"></i> Upload
          </button>
        </div>
      </div>
    </div>
}

    <!-- ============================================================ -->
    <!-- Mode B: View / Replace existing template (newUpload === false) -->
    <!-- ============================================================ -->
    @if (!newUpload) {
<div class="modal-body view-mode-body">

      <!-- PDF fills modal body (no view-mode-toolbar in PDF view — legacy icons omitted) -->
      <div class="pdf-section"
           [class.pdf-section--frame]="url && !loadingForm">
        @if (loadingForm) {
<div class="pdf-loader">
          <i class="fa fa-spinner fa-spin"></i> Loading template...
        </div>
}
        @if (!url && !loadingForm) {
<div class="pdf-empty">
          <p>Please upload the template to view the fields</p>
        </div>
}
        @if (url && !loadingForm) {
<iframe
                [src]="url"
                class="pdf-frame"
                frameborder="0"
                title="PDF Template"></iframe>
}
      </div>

      <!-- Comments Section -->
      @if (showComments) {
<div class="comments-section">
        <h5>Comments</h5>
        @if (allcomments.length > 0) {
<div class="comment-list">
          @for (c of allcomments; track $index) {
<div class="comment-item">
            <div class="comment-meta">{{ c.SSO_ID || c.CREATED_BY }} - {{ c.CREATED_DATE || c.CREATED_TS }}</div>
            <div class="comment-text">{{ c.COMMENT || c.COMMENTS }}</div>
          </div>
}
        </div>
}
        @if (allcomments.length === 0) {
<div class="no-comments">No comments found.</div>
}
      </div>
}

    </div>
}
  </div>
</div>
}
